export type SportsPreloadStrategy = 'idle' | 'interaction' | 'click';

type NavigatorWithDeviceSignals = {
  connection?: {
    downlink?: number;
    effectiveType?: string;
    rtt?: number;
    saveData?: boolean;
  };
  deviceMemory?: number;
  hardwareConcurrency?: number;
};

export function getSportsPreloadStrategy(
  browserNavigator: NavigatorWithDeviceSignals,
): SportsPreloadStrategy {
  const connection = browserNavigator.connection;
  const memory = browserNavigator.deviceMemory;
  const cores = browserNavigator.hardwareConcurrency;

  if (
    connection?.saveData === true ||
    ['slow-2g', '2g'].includes(connection?.effectiveType || '') ||
    (typeof memory === 'number' && memory <= 2)
  ) {
    return 'click';
  }

  const hasPerformanceSignals =
    connection?.effectiveType != null ||
    connection?.downlink != null ||
    connection?.rtt != null ||
    memory != null ||
    cores != null;

  if (
    !hasPerformanceSignals ||
    connection?.effectiveType === '3g' ||
    (typeof connection?.downlink === 'number' && connection.downlink < 2) ||
    (typeof connection?.rtt === 'number' && connection.rtt > 350) ||
    (typeof cores === 'number' && cores <= 4)
  ) {
    return 'interaction';
  }

  return 'idle';
}
